(()=>{
"use strict";
const SHOP = "/products/";
const ALL_SYRUPS = "/collections/simple-syrups";

// Cart links. Matcha + any number of picks. 3+ bottles unlocks $11 per bottle.
// matcha: the Single-bottle variant ID of Simps Matcha Tea Concentrate (add when it's live)
const DEAL_MIN = 3, DEAL_EACH = 11, REG_EACH = 13.99;
// live: flip to true on launch day, once Matcha has inventory
const CART = { store:"", matcha:54727207026961, live:true, variants:{"simps-strawberry-simple-syrup": 45342566351121, "strawberry-sugar-free-syrup": 50564771643665, "raspberry-syrup": 50564591026449, "simps-zero-sugar-raspberry-syrup": 50691840246033, "simps-blueberry-syrup": 50691849814289, "simps-huckleberry-syrup": 50691867640081, "simps_blackberry_syrup": 45695581159697, "simps_cherry_syrup": 45695581552913, "simps-watermelon-syrup": 53498013974801, "simps-zero-watermelon-syrup": 53498020954385, "simps_peach_syrup": 45695583256849, "simps-zero-sugar-peach-syrup": 50737313382673, "simps-mango-syrup": 46739254739217, "simps_passionfruit_syrup": 45695583191313, "simps_pineapple_syrup": 45695583387921, "simps_guava_syrup": 45695582535953, "simps_coffee_coconut_syrup": 45695581978897, "simps-zero-sugar-coconut-syrup": 50737334747409, "simps-banana-syrup": 50691874783505, "simps_coffee_vanilla_syrup": 45695582404881, "simps_coffee_vanilla_zero_syrup": 45695582470417, "simps-french-vanilla-syrup": 53458423644433, "simps-zero-french-vanilla": 53458738184465, "simps-brown-sugar-cinnamon-syrup": 50737324622097, "simps-salted-caramel-syrup": 50691860791569, "simps-zero-salted-caramel": 52085340504337, "simps_coffee_toasted_marshmallow_syrup": 45695582273809, "shortbread-syrup": 50564455137553, "simps-english-toffee-syrup": 50737249452305, "simps-zero-english-toffee": 52085345845521, "simps-pumpkin-spice": 52075871928593, "simps-zero-pumpkin-spice": 52492493521169, "simps-pistachio-syrup": 52530991300881, "simps-macadamia-nut-syrup": 50737297359121, "almond_orgeat_syrup": 45695581651217, "simps_coffee_hazelnut_syrup": 45695582142737, "simps-zero-sugar-hazelnut-syrup": 50737343725841, "simps_lavender_syrup": 45695582667025, "simps_rosemary_syrup": 45695583813905, "elderflower-syrup": 50461417341201, "simps-hibiscus-syrup": 50737226875153, "prickly-pear_syrup": 50564634378513, "simps_peppermint_syrup": 45695583322385, "simps-zero-sugar-peppermint": 52120045846801, "simps_lemonsour_syrup": 45695582830865, "simps-grapefruit-syrup": 50737281073425, "local-tonic-sodastream-concentrate": 50680072864017, "local-zero-tonic": 51546595721489, "local-ginger-beer-sodastream-concentrate": 50679970431249, "local-zero-ginger-beer": 51521405747473, "local-cream-soda-sodastream-concentrate": 50680139940113, "local-zero-sugar-cream-soda": 54619492483345, "local-orange-sodastream-concentrate": 50680025252113, "local-lemon-lime-sodastream-concentrate": 50680145805585, "local-zero-lemon-lime": 51469932691729, "local-black-cherry-sodastream-concentrate": 50680153604369} };
const variantOf = s => CART.variants[(S.zero&&s.zero)?s.zero:s.handle];
function cartLink(picks){
  if(!CART.live || !CART.matcha || !picks.length || picks.some(p=>!variantOf(p))) return null;
  return CART.store+"/cart/"+[CART.matcha,...picks.map(variantOf)].map(id=>id+":1").join(",");
}

const RESULTS = {
  fruity:  {emoji:"🍓", name:"Berry Bright", blurb:"You bring the snacks, the playlist and the pink drink everyone photographs. Fruit-forward matcha is your love language."},
  tropical:{emoji:"🥭", name:"Island Whisk", blurb:"Mentally on a beach at all times. You want your matcha sunny, juicy and a little bit on vacation."},
  cozy:    {emoji:"☁️", name:"Cozy Cloud", blurb:"Sweater weather is a personality and you have it. Warm, foamy, dessert-adjacent matcha is where you live."},
  active:  {emoji:"🥾", name:"Trail Blazer", blurb:"Up early, out the door and back in time for brunch. You like your matcha bright, refreshing and ready for the next adventure, and our Zero Sugar flavours keep up with you."},
  nutty:   {emoji:"🥜", name:"Nutty Professor", blurb:"You've read the ingredient list twice and have opinions. Rich, toasty, nutty matcha is your thing."},
  floral:  {emoji:"🌸", name:"Garden Party", blurb:"You whisk slowly and own at least one linen shirt. Floral and herby pairings bring out the best in your matcha."},
  fizzy:   {emoji:"🫧", name:"Fizz Kid", blurb:"Still matcha is fine, but have you tried it sparkling? You want it bright, zesty and bubbly."}
};

const QUIZ = [
  {q:"Pick a Saturday.", a:[
    ["🏖️","Beach towel, zero plans",{tropical:2}],
    ["🧺","Farmers market haul",{fruity:2}],
    ["🛋️","Blanket fort movie marathon",{cozy:2}],
    ["🥂","Patio with the whole crew",{fizzy:2}],
    ["🥾","Sunrise hike, then brunch",{active:3}]]},
  {q:"Pick a sound.", a:[
    ["🎐","Wind chimes",{floral:2}],
    ["🔥","A crackling fireplace",{cozy:2}],
    ["🥫","A can cracking open",{fizzy:2}],
    ["🎶","Someone playing ukulele",{tropical:2}],
    ["🌲","Wind in the trees on a trail",{active:2,floral:1}]]},
  {q:"How do you take your matcha?", a:[
    ["🍵","Whisked slowly, with intention",{floral:2}],
    ["🩷","I just want it pink",{fruity:2}],
    ["☁️","Extra foam, extra everything",{cozy:2}],
    ["🥛","Oat, almond, any nut milk",{nutty:2}]]},
  {q:"Pick a snack.", a:[
    ["🥜","Trail mix, obviously",{nutty:2,active:1}],
    ["🍉","A giant fruit salad",{fruity:2}],
    ["🍪","A warm cookie",{cozy:1, nutty:1}],
    ["🌶️","Mango with chili and lime",{tropical:2}]]},
  {q:"Your role in the group chat?", a:[
    ["📱","Sends memes at 2am",{fizzy:2}],
    ["🗺️","Plans the whole trip",{nutty:2}],
    ["🏃","Rallies everyone for the Saturday run",{active:2}],
    ["📣","Hypes everyone up",{fruity:2}],
    ["💌","Checks in on everybody",{floral:2}]]},
  {q:"Hot or iced?", temp:true, a:[
    ["☕","Hot, always","hot"],
    ["🧊","Iced, always","iced"],
    ["🌗","Depends on the day","both"]]},
  {q:"Sugar check.", sugar:true, a:[
    ["🍯","Full send",false],
    ["0️⃣","Keep it zero sugar",true]]}
];

// name, product handle, zero-sugar handle, colour, tags, drink, how-to, style
const SYRUPS = [
  ["Strawberry","simps-strawberry-simple-syrup","strawberry-sugar-free-syrup","#E8546B",{fruity:3,cozy:1},"Strawberry Matcha Cloud","1 oz Matcha + 2 pumps Strawberry, 5 oz cold milk, lots of ice.","latte"],
  ["Raspberry","raspberry-syrup","simps-zero-sugar-raspberry-syrup","#D6336C",{fruity:3,fizzy:1},"Razzle Matcha","1 oz Matcha + 1 pump Raspberry, 5 oz oat milk over ice.","latte"],
  ["Blueberry","simps-blueberry-syrup",null,"#5B5FC7",{fruity:2,cozy:2},"Blueberry Muffin Matcha","1 oz Matcha + 1 pump Blueberry in 5 oz warm milk, pinch of cinnamon.","latte"],
  ["Huckleberry","simps-huckleberry-syrup",null,"#7A3E8E",{fruity:3},"Huckleberry Hike","1 oz Matcha + 1 pump Huckleberry, 5 oz milk over ice.","latte"],
  ["Blackberry","simps_blackberry_syrup",null,"#4B2A4F",{fruity:2,floral:1},"Bramble Matcha","1 oz Matcha + 1 pump Blackberry, 5 oz milk over ice.","latte"],
  ["Cherry","simps_cherry_syrup",null,"#B5172F",{fruity:2,floral:1},"Cherry Blossom Matcha","1 oz Matcha + 1 pump Cherry, 5 oz milk over ice.","latte"],
  ["Watermelon","simps-watermelon-syrup","simps-zero-watermelon-syrup","#F2737E",{fruity:2,fizzy:1,tropical:1},"Watermelon Matcha Cooler","1 oz Matcha + 2 pumps Watermelon in 5 oz coconut water over ice.","fizz"],
  ["Peach","simps_peach_syrup","simps-zero-sugar-peach-syrup","#F6A77D",{fruity:2,tropical:1},"Peachy Matcha","1 oz Matcha + 1 pump Peach, 5 oz milk over ice.","latte"],
  ["Mango","simps-mango-syrup",null,"#F5A623",{tropical:3},"Mango Matcha Sunrise","1 oz Matcha + 2 pumps Mango, 5 oz coconut milk over ice.","latte"],
  ["Passionfruit","simps_passionfruit_syrup",null,"#F2B705",{tropical:3,fizzy:1},"Passion Pop Matcha","1 oz Matcha + 1 pump Passionfruit in 5 oz sparkling water over ice.","fizz"],
  ["Pineapple","simps_pineapple_syrup",null,"#F6D54A",{tropical:2,fizzy:1},"Pineapple Matcha Splash","1 oz Matcha + 1 pump Pineapple in 5 oz coconut water over ice.","fizz"],
  ["Guava","simps_guava_syrup",null,"#F28B82",{tropical:3},"Guava Matcha Dream","1 oz Matcha + 1 pump Guava, 5 oz milk over ice.","latte"],
  ["Coconut","simps_coffee_coconut_syrup","simps-zero-sugar-coconut-syrup","#E9DFC8",{tropical:2,cozy:1,nutty:1},"Coconut Cloud Matcha","1 oz Matcha + 2 pumps Coconut, shaken with 5 oz milk and ice.","latte"],
  ["Banana","simps-banana-syrup",null,"#F4D35E",{tropical:1,cozy:2},"Banana Bread Matcha","1 oz Matcha + 1 pump Banana in 5 oz warm oat milk.","latte"],
  ["Vanilla","simps_coffee_vanilla_syrup","simps_coffee_vanilla_zero_syrup","#F3E3B5",{cozy:3},"Classic Vanilla Matcha","1 oz Matcha + 1 pump Vanilla in 5 oz milk, hot or iced.","latte"],
  ["French Vanilla","simps-french-vanilla-syrup","simps-zero-french-vanilla","#E9CF8F",{cozy:3},"French Vanilla Foam Matcha","1 oz Matcha over 5 oz iced milk, topped with French Vanilla foam.","latte"],
  ["Brown Sugar Cinnamon","simps-brown-sugar-cinnamon-syrup",null,"#A0612B",{cozy:3},"Cinnamon Bun Matcha","1 oz Matcha + 1 pump Brown Sugar Cinnamon, 5 oz oat milk over ice.","latte"],
  ["Salted Caramel","simps-salted-caramel-syrup","simps-zero-salted-caramel","#C98A3D",{cozy:3},"Salted Caramel Matcha","1 oz Matcha + 1 pump Salted Caramel in 5 oz milk, hot or iced.","latte"],
  ["Toasted Marshmallow","simps_coffee_toasted_marshmallow_syrup",null,"#E8D3B0",{cozy:3},"Campfire Matcha","1 oz Matcha + 1 pump Toasted Marshmallow in 5 oz hot milk.","latte"],
  ["Shortbread","shortbread-syrup",null,"#E2B96F",{cozy:2,nutty:1},"Shortbread Matcha","1 oz Matcha + 1 pump Shortbread, 5 oz milk over ice.","latte"],
  ["English Toffee","simps-english-toffee-syrup","simps-zero-english-toffee","#9C5A26",{cozy:2,nutty:1},"Toffee Matcha","1 oz Matcha + 1 pump English Toffee in 5 oz hot milk.","latte"],
  ["Pumpkin Spice","simps-pumpkin-spice","simps-zero-pumpkin-spice","#D2691E",{cozy:3},"Pumpkin Spice Matcha","1 oz Matcha + 1 pump Pumpkin Spice in 5 oz hot milk, foam on top.","latte"],
  ["Pistachio","simps-pistachio-syrup",null,"#A3C585",{nutty:3},"Pistachio Matcha","1 oz Matcha + 2 pumps Pistachio, 5 oz milk over ice. Double green.","latte"],
  ["Macadamia Nut","simps-macadamia-nut-syrup",null,"#D9C3A0",{nutty:3,tropical:1},"Macadamia Matcha","1 oz Matcha + 1 pump Macadamia Nut, 5 oz oat milk over ice.","latte"],
  ["Almond Orgeat","almond_orgeat_syrup",null,"#E6D2B5",{nutty:3},"Almond Matcha","1 oz Matcha + 1 pump Almond Orgeat in 5 oz almond milk.","latte"],
  ["Hazelnut","simps_coffee_hazelnut_syrup","simps-zero-sugar-hazelnut-syrup","#8B5A2B",{nutty:3,cozy:1},"Hazelnut Matcha","1 oz Matcha + 1 pump Hazelnut in 5 oz hot milk.","latte"],
  ["Lavender","simps_lavender_syrup",null,"#B39DDB",{floral:3},"Lavender Haze Matcha","1 oz Matcha + 1 pump Lavender, 5 oz oat milk over ice.","latte"],
  ["Rosemary","simps_rosemary_syrup",null,"#6B8E6B",{floral:3,fizzy:1},"Rosemary Matcha Tonic","1 oz Matcha + 1 pump Rosemary, then 1 oz LOCAL Tonic syrup and 10 oz soda water over ice.","fizz"],
  ["Elderflower","elderflower-syrup",null,"#E6E0A8",{floral:3,fizzy:2},"Elderflower Matcha Spritz","1 oz Matcha + 1 pump Elderflower, 5 oz sparkling water, lemon wedge.","fizz"],
  ["Hibiscus","simps-hibiscus-syrup",null,"#B3124E",{floral:3,fruity:1},"Hibiscus Matcha","1 oz Matcha + 1 pump Hibiscus, 5 oz milk over ice.","latte"],
  ["Prickly Pear","prickly-pear_syrup",null,"#E0457B",{floral:2,fruity:2},"Pink Desert Matcha","1 oz Matcha + 1 pump Prickly Pear, 5 oz milk over ice.","latte"],
  ["Peppermint","simps_peppermint_syrup","simps-zero-sugar-peppermint","#9FE2BF",{cozy:1,fizzy:1,floral:1},"Mint Matcha","1 oz Matcha + a half pump Peppermint in 5 oz milk, hot or iced.","latte"],
  ["Lemon Sour","simps_lemonsour_syrup",null,"#F7E26B",{fizzy:3,fruity:1},"Matcha Lemonade","1 oz Matcha + 2 pumps Lemon Sour in 5 oz cold water over ice.","fizz"],
  ["Grapefruit","simps-grapefruit-syrup",null,"#F28C6B",{fizzy:3},"Grapefruit Matcha Tonic","1 oz Matcha + 1 pump Grapefruit, then 1 oz LOCAL Tonic syrup and 10 oz soda water over ice.","fizz"],
  ["Local Tonic","local-tonic-sodastream-concentrate","local-zero-tonic","#D8EEF0",{fizzy:3},"Matcha Tonic","1 oz LOCAL Tonic syrup + 5 oz soda water makes the tonic. Add ice, then 1 oz Matcha + 5 oz more soda water.","fizz"],
  ["Local Ginger Beer","local-ginger-beer-sodastream-concentrate","local-zero-ginger-beer","#E0B64A",{fizzy:3},"Matcha Ginger Fizz","1 oz LOCAL Ginger Beer syrup + 5 oz soda water makes the ginger beer. Add ice, then 1 oz Matcha + 5 oz more soda water.","fizz"],
  ["Local Cream Soda","local-cream-soda-sodastream-concentrate","local-zero-sugar-cream-soda","#F3D9A4",{fizzy:2,cozy:2},"Matcha Cream Soda Float","1 oz LOCAL Cream Soda syrup + 5 oz soda water, ice, 1 oz Matcha + 5 oz more soda water, splash of cream.","fizz"],
  ["Local Orange","local-orange-sodastream-concentrate",null,"#F7931E",{fizzy:2,cozy:1,tropical:1},"Matcha Creamsicle","1 oz LOCAL Orange syrup + 5 oz soda water, ice, 1 oz Matcha + 5 oz more soda water, splash of cream.","fizz"],
  ["Local Lemon Lime","local-lemon-lime-sodastream-concentrate","local-zero-lemon-lime","#C5E063",{fizzy:3},"Matcha Sparkler","1 oz LOCAL Lemon Lime syrup + 5 oz soda water, ice, then 1 oz Matcha + 5 oz more soda water.","fizz"],
  ["Local Black Cherry","local-black-cherry-sodastream-concentrate",null,"#6A1430",{fizzy:2,fruity:2},"Black Cherry Matcha Soda","1 oz LOCAL Black Cherry syrup + 5 oz soda water, ice, then 1 oz Matcha + 5 oz more soda water.","fizz"]
].map(([name,handle,zero,color,tags,drink,how,style],i)=>({id:i,name,handle,zero,color,tags,drink,how,style}));

// hot and iced versions (sodas and spritzes are iced only)
const HOT = {"Strawberry": "1 oz Matcha + 2 pumps Strawberry, whisked into 5 oz steamed milk.", "Raspberry": "1 oz Matcha + 1 pump Raspberry in 5 oz steamed oat milk.", "Blueberry": "1 oz Matcha + 1 pump Blueberry in 5 oz warm milk, pinch of cinnamon.", "Huckleberry": "1 oz Matcha + 1 pump Huckleberry in 5 oz steamed milk.", "Blackberry": "1 oz Matcha + 1 pump Blackberry in 5 oz steamed milk.", "Cherry": "1 oz Matcha + 1 pump Cherry in 5 oz steamed milk.", "Peach": "1 oz Matcha + 1 pump Peach in 5 oz steamed milk.", "Mango": "1 oz Matcha + 1 pump Mango in 5 oz steamed coconut milk.", "Guava": "1 oz Matcha + 1 pump Guava in 5 oz steamed milk.", "Coconut": "1 oz Matcha + 2 pumps Coconut in 5 oz steamed coconut milk.", "Banana": "1 oz Matcha + 1 pump Banana in 5 oz warm oat milk.", "Vanilla": "1 oz Matcha + 1 pump Vanilla in 5 oz steamed milk.", "French Vanilla": "1 oz Matcha in 5 oz steamed milk, topped with French Vanilla foam.", "Brown Sugar Cinnamon": "1 oz Matcha + 1 pump Brown Sugar Cinnamon in 5 oz steamed oat milk.", "Salted Caramel": "1 oz Matcha + 1 pump Salted Caramel in 5 oz steamed milk.", "Toasted Marshmallow": "1 oz Matcha + 1 pump Toasted Marshmallow in 5 oz hot milk.", "Shortbread": "1 oz Matcha + 1 pump Shortbread in 5 oz steamed milk.", "English Toffee": "1 oz Matcha + 1 pump English Toffee in 5 oz hot milk.", "Pumpkin Spice": "1 oz Matcha + 1 pump Pumpkin Spice in 5 oz hot milk, foam on top.", "Pistachio": "1 oz Matcha + 2 pumps Pistachio in 5 oz steamed milk. Double green.", "Macadamia Nut": "1 oz Matcha + 1 pump Macadamia Nut in 5 oz steamed oat milk.", "Almond Orgeat": "1 oz Matcha + 1 pump Almond Orgeat in 5 oz steamed almond milk.", "Hazelnut": "1 oz Matcha + 1 pump Hazelnut in 5 oz hot milk.", "Lavender": "1 oz Matcha + 1 pump Lavender in 5 oz steamed oat milk.", "Hibiscus": "1 oz Matcha + 1 pump Hibiscus in 5 oz steamed milk.", "Prickly Pear": "1 oz Matcha + 1 pump Prickly Pear in 5 oz steamed milk.", "Peppermint": "1 oz Matcha + a half pump Peppermint in 5 oz steamed milk."};
const ICED = {"Blueberry": "1 oz Matcha + 1 pump Blueberry, 5 oz cold milk over ice, pinch of cinnamon.", "Banana": "1 oz Matcha + 1 pump Banana, 5 oz oat milk over ice.", "Vanilla": "1 oz Matcha + 1 pump Vanilla, 5 oz cold milk over ice.", "Salted Caramel": "1 oz Matcha + 1 pump Salted Caramel, 5 oz cold milk over ice.", "Toasted Marshmallow": "1 oz Matcha + 1 pump Toasted Marshmallow, 5 oz cold milk over ice.", "English Toffee": "1 oz Matcha + 1 pump English Toffee, 5 oz oat milk over ice.", "Pumpkin Spice": "1 oz Matcha + 1 pump Pumpkin Spice, 5 oz cold milk over ice, foam on top.", "Almond Orgeat": "1 oz Matcha + 1 pump Almond Orgeat, 5 oz almond milk over ice.", "Hazelnut": "1 oz Matcha + 1 pump Hazelnut, 5 oz cold milk over ice.", "Peppermint": "1 oz Matcha + a half pump Peppermint, 5 oz cold milk over ice."};
SYRUPS.forEach(s=>{ s.iced = ICED[s.name] || s.how; s.hot = HOT[s.name] || null; });
const servedHot = s => S.temp==="hot" && !!s.hot;
function howHTML(s, cls){
  if(S.temp==="hot") return `<p class="${cls}">${s.hot || s.iced}${s.hot?"":" <em>Best iced.</em>"}</p>`;
  if(S.temp==="iced" || !s.hot) return `<p class="${cls}">${s.iced}</p>`;
  return `<p class="${cls}"><b>🧊 Iced:</b> ${s.iced}</p><p class="${cls} two"><b>☕ Hot:</b> ${s.hot}</p>`;
}

// light, refreshing picks that suit an active day
const ACTIVE = {"Watermelon":3,"Lemon Sour":3,"Grapefruit":2,"Peach":2,"Coconut":2,"Pineapple":2,"Local Ginger Beer":2,"Local Lemon Lime":2,"Strawberry":1,"Mango":1,"Elderflower":1,"Peppermint":1};
SYRUPS.forEach(s=>{ if(ACTIVE[s.name]) s.tags.active=ACTIVE[s.name]; });

const S = {step:"intro", qi:0, scores:{}, zero:false, deck:[], idx:0, liked:[], top:null};
const app = document.getElementById("mq-app");
if(!app) return;
let keyFn=null;
document.addEventListener("keydown", e=>{ if(keyFn) keyFn(e); });
let uid = 0;

function shade(hex, amt){
  const n=parseInt(hex.slice(1),16); let r=n>>16,g=n>>8&255,b=n&255;
  const f=v=>Math.max(0,Math.min(255,Math.round(v+amt)));
  return "#"+[f(r),f(g),f(b)].map(v=>v.toString(16).padStart(2,"0")).join("");
}

function cup(color, style="latte", hot=false){
  const id="mqg"+(++uid);
  const mid = style==="fizz" ? "#E6F4EC" : "#F7F5EA";
  const bubbles = style==="fizz" ? [[46,118,3],[70,128,2.5],[58,100,2],[80,108,3],[40,136,2]].map(([x,y,r])=>`<circle cx="${x}" cy="${y}" r="${r}" fill="#fff" opacity=".8"/>`).join("") : "";
  return `<svg viewBox="0 0 120 170" aria-hidden="true">
  <defs>
    <linearGradient id="${id}" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#9BBE4A"/><stop offset=".27" stop-color="#7FA23A"/>
      <stop offset=".42" stop-color="${mid}"/><stop offset=".58" stop-color="${mid}"/>
      <stop offset=".74" stop-color="${color}"/><stop offset="1" stop-color="${shade(color,-40)}"/>
    </linearGradient>
    <clipPath id="c${id}"><path d="M22 34 L98 34 L90 156 Q60 163 30 156 Z"/></clipPath>
  </defs>
  ${hot?`<g fill="none" stroke="var(--soft)" stroke-width="3" stroke-linecap="round" opacity=".7"><path d="M44 26 q-6 -8 0 -14 q6 -6 0 -12"/><path d="M60 24 q-6 -8 0 -14 q6 -6 0 -12"/><path d="M76 26 q-6 -8 0 -14 q6 -6 0 -12"/></g>`:`<rect x="71" y="4" width="9" height="70" rx="4" fill="${color}" stroke="var(--line)" stroke-width="2.5" transform="rotate(14 75 40)"/>`}
  <g clip-path="url(#c${id})">
    <path d="M10 48 Q30 40 60 46 T110 44 L110 170 L10 170 Z" fill="url(#${id})"/>
    ${hot?"":`<rect x="34" y="62" width="20" height="18" rx="5" fill="#fff" opacity=".55" transform="rotate(-12 44 71)"/>
    <rect x="60" y="74" width="18" height="16" rx="5" fill="#fff" opacity=".5" transform="rotate(10 69 82)"/>`}
    ${bubbles}
  </g>
  <path d="M22 34 L98 34 L90 156 Q60 163 30 156 Z" fill="none" stroke="var(--line)" stroke-width="3" stroke-linejoin="round"/>
  <path d="M30 44 L36 142" stroke="#fff" stroke-width="4" stroke-linecap="round" opacity=".5"/>
</svg>`;
}

const LOGO_L=(window.MQ_LOGOS||{}).l||"", LOGO_D=(window.MQ_LOGOS||{}).d||"";
function brand(){ return `<div class="brand"><span class="logo"><img class="lg-l" src="${LOGO_L}" alt="Simps Modern Beverage" width="92" height="40"><img class="lg-d" src="${LOGO_D}" alt="Simps Modern Beverage" width="92" height="40"></span><span class="tag">Matcha your flavours</span></div>`; }

function render(){
  { const t=app.getBoundingClientRect().top; if(t<0) app.scrollIntoView({block:"start"}); }
  if(S.step==="intro") return intro();
  if(S.step==="quiz") return quiz();
  if(S.step==="result") return result();
  if(S.step==="deck") return deck();
  if(S.step==="matches") return matches();
}

function intro(){
  app.innerHTML = `${brand()}
  <section class="hero">
    <h1>Matcha<span>your flavours</span></h1>
    <div class="hero-cup">${cup("#E8546B")}${cup("#B39DDB")}${cup("#F5A623","fizz")}</div>
    <p>A few silly questions, then swipe through drinks made with our new Matcha Tea Concentrate and the Simps flavour it pairs with. Keep the ones you'd sip.</p>
    <div class="stack"><button class="btn block" data-act="start">Start the quiz</button></div>
  </section>
  <p class="foot">Takes about a minute. No sign-up.</p>`;
}

function quiz(){
  const item = QUIZ[S.qi];
  app.innerHTML = `${brand()}
  <div class="progress">${QUIZ.map((_,i)=>`<i class="${i<=S.qi?"on":""}"></i>`).join("")}</div>
  <section class="q">
    <h2>${item.q}</h2>
    <div class="opts">${item.a.map((a,i)=>`<button class="opt" data-i="${i}"><span class="em">${a[0]}</span>${a[1]}</button>`).join("")}</div>
  </section>`;
  let picked=false;
  app.querySelectorAll(".opt").forEach(b=>b.onclick=()=>{
    if(picked) return; picked=true;
    b.classList.add("picked");
    const a = item.a[+b.dataset.i];
    if(item.temp) S.temp = a[2];
    else if(item.sugar){ S.zero = a[2]; if(a[2]) S.scores.active=(S.scores.active||0)+1; }
    else for(const k in a[2]) S.scores[k]=(S.scores[k]||0)+a[2][k];
    setTimeout(()=>{ S.qi++; if(S.qi>=QUIZ.length){ buildDeck(); S.step="result"; } render(); }, 220);
  });
}

function buildDeck(){
  const order = ["fruity","tropical","cozy","nutty","floral","fizzy","active"];
  S.top = order.reduce((best,k)=> (S.scores[k]||0) > (S.scores[best]||0) ? k : best, order[0]);
  const scored = SYRUPS.map(s=>{
    let v=0; for(const k in s.tags) v += s.tags[k]*(S.scores[k]||0);
    if(S.zero && s.zero) v += 3;
    if(S.temp==="hot" && !s.hot) v -= 8;
    return {...s, score:v + Math.random()};
  }).sort((a,b)=>b.score-a.score);
  const main = scored.slice(0,9);
  const rest = scored.slice(9).filter(s=>S.temp!=="hot"||s.hot).sort(()=>Math.random()-.5).slice(0,3).map(s=>({...s,wild:true}));
  const deck = [...main]; rest.forEach((w,i)=>deck.splice(3+i*3,0,w));
  S.deck = deck; S.idx = 0; S.liked = []; S.pool = null;
}

function result(){
  const r = RESULTS[S.top];
  app.innerHTML = `${brand()}
  <section class="result">
    <span class="big" aria-hidden="true">${r.emoji}</span>
    <small>Your matcha personality</small>
    <h2>${r.name}</h2>
    <p>${r.blurb}</p>
    <div class="stack"><button class="btn block" data-act="swipe">Swipe my pairings</button>
    <button class="btn ghost block" data-act="start">Retake the quiz</button></div>
  </section>`;
}

function cardHTML(s, back){
  const useZero = S.zero && s.zero;
  return `<article class="card" style="--c:${s.color}">
    <div class="swatch"></div>
    <span class="stamp sip">SIP ♥</span><span class="stamp skip">SKIP</span>
    <div class="art">${cup(s.color, s.style, servedHot(s))}</div>
    <div class="info">
      <div class="chips">${s.wild?`<span class="chip wild">Wildcard</span>`:""}${useZero?`<span class="chip zero">Zero sugar</span>`:""}${s.name.startsWith("Local")?`<span class="chip">Local soda</span>`:""}</div>
      <h3>${s.drink}</h3>
      <p class="syrup">Matcha + ${useZero?"Zero Sugar ":""}${s.name}</p>
      ${howHTML(s,"how")}
    </div>
  </article>`;
}

function deck(){
  app.innerHTML = `${brand()}
  <div class="deck-head"><h2>Would you sip it?</h2><span id="mq-count"></span></div>
  <div class="deck" id="mq-deck"></div>
  <div class="controls">
    <button class="round" id="mq-no" aria-label="Skip this drink">✕</button>
    <button class="round small" id="mq-undo" aria-label="Undo last swipe">↺</button>
    <button class="round yes" id="mq-yes" aria-label="Sip this drink">♥</button>
  </div>
  <p class="hint">Grab the card and fling it. Right to keep, left to skip.</p>`;
  const deckEl=document.getElementById("mq-deck");
  const clamp=v=>Math.max(0,Math.min(1,v));
  const reduce=matchMedia("(prefers-reduced-motion: reduce)").matches;
  const spring="transform .45s cubic-bezier(.2,1.5,.4,1)";
  let busy=false; const history=[];

  const place=(el,d,p=0)=>{ const k=Math.max(0,d-p); el.style.transform=`translateY(${k*16}px) scale(${1-k*.05})`; el.style.zIndex=10-d; };
  const behind=()=>[...deckEl.children].slice(0,-1);
  const lift=(p,t)=>behind().forEach(el=>{ el.style.transition=t||"none"; place(el,+el.dataset.d,p); });

  function mount(){
    const items=S.deck.slice(S.idx,S.idx+3);
    if(!items.length){ S.step="matches"; return render(); }
    deckEl.innerHTML="";
    items.map((c,d)=>({c,d})).reverse().forEach(({c,d})=>{
      const w=document.createElement("div"); w.innerHTML=cardHTML(c);
      const el=w.firstElementChild; el.dataset.d=d; place(el,d);
      if(d>0) el.setAttribute("aria-hidden","true");
      deckEl.appendChild(el);
    });
    document.getElementById("mq-count").textContent=`${S.idx+1} of ${S.deck.length}, ♥ ${S.liked.length} kept`;
    document.getElementById("mq-undo").disabled=!history.length;
    bind(deckEl.lastElementChild);
  }

  function bind(card){
    const sip=card.querySelector(".sip"), skip=card.querySelector(".skip");
    let sx=0,sy=0,dx=0,dy=0,flip=1,lx=0,lt=0,vx=0,on=false,buzz=false;
    const paint=()=>{
      card.style.transform=`translate(${dx}px,${dy}px) rotate(${dx*.07*flip}deg)`;
      sip.style.opacity=clamp(dx/100); skip.style.opacity=clamp(-dx/100);
      lift(clamp(Math.abs(dx)/140));
    };
    card.addEventListener("dragstart",e=>e.preventDefault());
    card.addEventListener("pointerdown",e=>{
      if(busy||e.button>0) return; e.preventDefault(); on=true; buzz=false;
      sx=lx=e.clientX; sy=e.clientY; lt=performance.now(); vx=0; dx=dy=0;
      const r=card.getBoundingClientRect(); flip=(e.clientY-r.top)<r.height*.6?1:-1;
      card.style.transition="none"; card.classList.add("grab");
      addEventListener("pointermove",move); addEventListener("pointerup",up); addEventListener("pointercancel",up);
    });
    function move(e){
      if(!on) return; dx=e.clientX-sx; dy=e.clientY-sy;
      const t=performance.now(); vx=(e.clientX-lx)/Math.max(1,t-lt); lx=e.clientX; lt=t;
      if(!buzz&&Math.abs(dx)>110){ buzz=true; navigator.vibrate&&navigator.vibrate(8); }
      paint();
    }
    function up(){
      if(!on) return; on=false; card.classList.remove("grab");
      removeEventListener("pointermove",move); removeEventListener("pointerup",up); removeEventListener("pointercancel",up);
      if(Math.abs(dx)>110||(Math.abs(vx)>.5&&Math.abs(dx)>40)) fly(card,dx>0?1:-1,dx,dy);
      else { card.style.transition=spring; dx=dy=0; card.style.transform="translate(0,0) rotate(0)"; sip.style.opacity=0; skip.style.opacity=0; lift(0,spring); }
    }
  }

  function fly(card,dir,dx=0,dy=0){
    if(busy||!card) return; busy=true;
    card.querySelector(dir>0?".sip":".skip").style.opacity=1;
    const outY=Math.max(-320,Math.min(320, dy+(Math.abs(dx)>20?dy/Math.abs(dx)*240:0)));
    card.style.transition=reduce?"none":"transform .4s cubic-bezier(.3,.7,.4,1)";
    card.style.transform=`translate(${dir*(innerWidth+240)}px,${outY}px) rotate(${dir*38}deg)`;
    lift(1,"transform .32s ease-out");
    if(dir>0) S.liked.push(S.deck[S.idx]);
    history.push({idx:S.idx,dir});
    setTimeout(()=>{ S.idx++; busy=false; mount(); }, reduce?0:360);
  }

  function undo(){
    if(busy||!history.length) return;
    const h=history.pop(); S.idx=h.idx; if(h.dir>0) S.liked.pop();
    mount();
    const top=deckEl.lastElementChild; if(reduce) return;
    top.style.transition="none";
    top.style.transform=`translate(${h.dir*(innerWidth+240)}px,-60px) rotate(${h.dir*38}deg)`;
    top.getBoundingClientRect();
    top.style.transition=spring; top.style.transform="translate(0,0) rotate(0)";
  }

  document.getElementById("mq-yes").onclick=()=>fly(deckEl.lastElementChild,1);
  document.getElementById("mq-no").onclick=()=>fly(deckEl.lastElementChild,-1);
  document.getElementById("mq-undo").onclick=undo;
  keyFn=e=>{ if(S.step!=="deck") return;
    if(/input|textarea|select/i.test((e.target&&e.target.tagName)||"")) return;
    if(e.key==="ArrowRight") fly(deckEl.lastElementChild,1);
    if(e.key==="ArrowLeft") fly(deckEl.lastElementChild,-1);
    if(e.key==="Backspace") undo(); };
  mount();
}

function label(s){ return ((S.zero&&s.zero)?"Zero Sugar ":"")+s.name+(s.name.startsWith("Local")?"":" Syrup"); }

function row(s){
  const on=S.sel.has(s.id);
  return `<div class="m${on?" in":""}">${cup(s.color,s.style,servedHot(s))}<div>
    ${s.sugg?`<span class="chip sugg">Suggested for you</span>`:""}
    <h4>${s.drink}</h4>${howHTML(s,"s")}
    <div class="acts">
      <button class="pick${on?" on":""}" data-act="toggle" data-id="${s.id}" aria-pressed="${on}">${on?"✓ In my pack":"+ Add to pack"}</button>
      <a class="lnk" href="${SHOP+((S.zero&&s.zero)?s.zero:s.handle)}" target="_blank" rel="noopener">View ${label(s)}</a>
    </div>
    ${/LOCAL Tonic syrup/.test(s.how)&&s.name!=="Local Tonic"?`<p class="upsell">Finish it with LOCAL Tonic. <a href="${SHOP+(S.zero?"local-zero-tonic":"local-tonic-sodastream-concentrate")}" target="_blank" rel="noopener">Add ${S.zero?"Zero Sugar ":""}LOCAL Tonic →</a></p>`:""}
    </div></div>`;
}

function buildPool(){
  const liked=S.liked.map(s=>s.id);
  // always show a few extras; pre-pick enough to reach the 3-bottle deal
  const need=Math.max(3,DEAL_MIN-1-liked.length);
  const sugg=S.deck.filter(s=>!liked.includes(s.id)).sort((a,b)=>(a.wild?1:0)-(b.wild?1:0)).slice(0,need).map(s=>({...s,sugg:true}));
  S.pool=[...S.liked,...sugg];
  S.sel=new Set(S.pool.slice(0,Math.max(liked.length,DEAL_MIN-1)).map(s=>s.id));
}

function matches(){
  if(!S.pool) buildPool();
  const r=RESULTS[S.top], has=S.liked.length>0;
  const picks=S.pool.filter(s=>S.sel.has(s.id));
  const bottles=picks.length+1, deal=bottles>=DEAL_MIN, cart=cartLink(picks);
  const money=n=>"$"+(Math.round(n*100)/100).toFixed(2).replace(/\.00$/,"");
  const priceLine = deal
    ? `${bottles} bottles at $${DEAL_EACH} each, about ${money(bottles*DEAL_EACH)} (you save ${money(bottles*(REG_EACH-DEAL_EACH))})`
    : `Add ${DEAL_MIN-bottles} more to unlock $${DEAL_EACH} a bottle`;
  const cta = cart
    ? `<a class="btn block" href="${cart}">Get Matcha + my ${picks.length} pick${picks.length>1?"s":""}</a>`
    : `<button class="btn block" disabled>${picks.length?"Matcha drops soon":"Pick at least one flavour"}</button>`;
  app.innerHTML = `${brand()}
  <section class="matches">
    <h2>${has?"Your matcha matches":"Tough crowd!"}</h2>
    <p>${r.emoji} ${r.name}. ${has?"":"Nothing made the cut, so we picked a few to start with. "}Build your bundle: Simps Matcha Tea Concentrate plus any flavours you like. 3 or more bottles are $${DEAL_EACH} each.</p>
    <div class="packbar${deal?" deal":""}"><strong>Matcha + ${picks.length} flavour${picks.length===1?"":"s"}</strong><span>${priceLine}</span></div>
    ${S.zero?`<p class="note left">Your flavours are Zero Sugar. Simps Matcha Tea Concentrate comes in one recipe, so it's the regular version.</p>`:""}
    <div class="mlist">${S.pool.map(row).join("")}</div>
    <div class="stack">
      ${cta}
      ${CART.live?"":`<p class="note">Simps Matcha Tea Concentrate launches soon. Your pack is ready when it does.</p>`}
      <button class="btn ghost block" data-act="again">Swipe a new deck</button>
      <button class="btn ghost block" data-act="start">Retake the quiz</button>
    </div>
  </section>
  <p class="foot">Matcha Tea Concentrate mixes 1 part to 5 parts milk or water. 1 oz Matcha + 5 oz milk makes one drink.</p>`;
}

// one click handler for every screen button, so none can go missing
function startQuiz(){ Object.assign(S,{step:"quiz",qi:0,scores:{},zero:false,temp:"both",liked:[],deck:[],idx:0,pool:null}); render(); }
app.addEventListener("click",e=>{
  const b=e.target.closest("[data-act]"); if(!b) return;
  const a=b.dataset.act;
  if(a==="start") startQuiz();
  if(a==="swipe"){ S.step="deck"; render(); }
  if(a==="again"){ buildDeck(); S.step="deck"; render(); }
  if(a==="toggle"){ const id=+b.dataset.id;
    if(S.sel.has(id)) S.sel.delete(id); else S.sel.add(id);
    matches(); }
});

render();
})();
